import { DefaultLayout } from "~/layouts/DefaultLayout";
import { MetaHeader } from "~/components/MetaHeader";
import { CafePage } from "~/components/CafePage";
import { useLoaderData, LoaderFunction } from 'remix';
import { SupabaseClientFn } from '~/utils/db.server';


export const loader: LoaderFunction = async ({ request }) => {
    const url = new URL(request.url);
    const shopId = url.searchParams.get('shop');

    try {
        // 各種情報を非同期に取得
        const [shopDetails, shopClosedDays, shopBusinessHours, embeds, shopImages] = await Promise.all([
            SupabaseClientFn.from('shops').select('*').eq('shop_id', shopId),
            SupabaseClientFn.from('shop_business_days').select(`business_days!inner(day_name)`).eq('shop_id', shopId).eq('is_closed', true),
            SupabaseClientFn.from('shop_business_days').select(`business_hours_start,business_hours_end,is_closed`).eq('shop_id', shopId).eq('day_id', new Date().getDay()),
            SupabaseClientFn.from('embeds').select("embed_name,embed_id").eq('shop_id', shopId),
            SupabaseClientFn.from('shop_images').select(`images!inner(image_url,photographer_icon,photographer_name),shops!inner(shop_name)`).eq('shop_id', shopId)
        ]);

        // エラーチェック
        const responses = [shopDetails, shopClosedDays, shopBusinessHours, embeds, shopImages];
        responses.forEach(response => {
            if (response.error) throw new Error(response.error.message);
        });

        // データの加工
        const processedData = {
            shopDetails: shopDetails.data[0],
            shopClosedDays: shopClosedDays?.data.map(item => item.business_days.day_name),
            shopBusinessHours: shopBusinessHours?.data[0],
            embeds: embeds.data,
            shopImages: shopImages.data
        };

        // データをJSONとして返す
        return new Response(JSON.stringify(processedData), {
            headers: { "Content-Type": "application/json" },
        });
    } catch (error) {
        console.error("Error fetching data:", error);
        return new Response(JSON.stringify({ message: "Error fetching data", error: error }), {
            status: 500,
            headers: { "Content-Type": "application/json" },
        });
    }
};


const Cafe: React.VFC = () => {
    const data = useLoaderData();
    return (
        <>
            <MetaHeader title={data.shopDetails.shop_name + " | " + data.shopDetails.shop_slogan} description={data.shopDetails.shop_description} />

            <DefaultLayout>
                <CafePage processedData={data} />
            </DefaultLayout>
        </>
    );
};

export default Cafe;
